import { Routes, Route } from "react-router-dom";
import MainPage from "./pages/mainPage/MainPage";
import Novaposhta from "./pages/novaposhta/Novaposhta";
import Ttn from "./pages/ttn/Ttn";
import Repairs from "./pages/repairs/Repairs";
import Repair from "./pages/reapair/Repair";
import RepairsService from "./pages/repairsService/RepairsService";
import Shipments from "./pages/shipments/Shipments";
import RepairsServiceVifi from "./pages/repairsServiceVifi/RepairsServiceVifi";
import RepairsServiceBuybest from "./pages/repairsServiceBuybest/RepairsServiceBuybest";
import Orders from "./pages/orders/Orders";
import Order from "./pages/order/Order";
import Clients from "./pages/clients/Clients";
import Requests from "./pages/requests/Requests";
import Exchanges from "./pages/exchanges/Exchanges";
import Products from "./pages/products/Products";
import Product from "./pages/product/Product";
import Categories from "./pages/categories/Categories";
import Models from "./pages/models/Models";
import Features from "./pages/features/Features";
import ReportsOrder from "./pages/reports/reportsOrder/ReportsOrder";
import ReportsBonuses from "./pages/reports/reportsBonuses/ReportsBonuses";
import ReportsProducts from "./pages/reports/reportsProducts/ReportsProducts";
import ReportsRepairs from "./pages/reports/reportsRepairs/ReportsRepairs";
import ReportsShipper from "./pages/reports/reportsshipper/ReportsShipper";
import ReportsWeb from "./pages/reports/reportsWeb/ReportsWeb";
import ReportsSync from "./pages/reports/reportsSync/ReportsSync";
import Import from "./pages/import/Import";
import Export from "./pages/export/Export";
import Stores from "./pages/stores/Stores";
import Managers from "./pages/managers/Managers";
import Shippers from "./pages/shippers/Shippers";
import Services from "./pages/services/Services";
import Logs from "./pages/logs/Logs";
import Request from "./pages/request/Request";
import Category from "./pages/category/Category";
import Model from "./pages/model/Model";
import Feature from "./pages/feature/Feature";
import Store from "./pages/store/Store";
import Manager from "./pages/manager/Manager";
import Shipper from "./pages/shipper/Shipper";
import Service from "./pages/service/Service";
import LogsBackup from "./pages/logs_backup/LogsBackup";
import Client from "./pages/client/Client";
import Login from "./pages/login/Login";
import Loading from "./pages/loading/Loading";
import PrivatRouts from "./components/PrivatRouts";
import CurrentManager from "./pages/currentManager/CurrentManeger";
import CurrentStore from "./pages/currentStore/CurrentStore";
import CurrentService from "./pages/currentService/CurrentService";
import CurrentCategory from "./pages/currentCategory/CurrentCategory";
import CurrentShipper from "./pages/currentShipper/CurrentShipper";
import CurrentModel from "./pages/currentModel/CurrentModel";
import CurrentFeature from "./pages/currentFeaute/CurrentFeature";
import CurrentProduct from "./pages/currentProduct/CurrentProduct";
import PrintBarcode from "./pages/prinpBarcode/PrintBarcode";
import CurrentClient from "./pages/currentClient.js/CurrentClient";
import CurrentOrder from "./pages/currentOrder/CurrentOrder";
import CurrentRepair from "./pages/currentRepair/CurrentRepair";
import PrintRepair from "./pages/print/PrintRepair";
import PrintOrder from "./pages/print/PrintOrder";
import CurrentRequest from "./pages/currentRequest/CurrentRequest";
import NotFound from "./pages/notFound/NotFound";
import CurrentTtn from "./pages/currenTtn/CurrentTtn";

const Rotes = () => {
    return (
        <Routes>
            <Route exact path="*" element={<NotFound />} />
            <Route exact path="/" element={<Loading />} />
            <Route path="/login" element={<Login />} />
            <Route element={<PrivatRouts />}>
                <Route path="/main" element={<MainPage />} />
                <Route path="/novaposhta/:statusParam" element={<Novaposhta />} />
                <Route path="/ttn" element={<Ttn />} />
                <Route path="/ttn/:id" element={<CurrentTtn />} />
                <Route path="/repairs" element={<Repairs />} />
                <Route path="/repair" element={<Repair />} />
                <Route path="/repair/:id" element={<CurrentRepair />} />
                <Route path="/repairs_service" element={<RepairsService />} />
                <Route path="/shipments" element={<Shipments />} />
                <Route path="/repairs_service/:id" element={<RepairsServiceVifi />} />
                <Route path="/repairs_service_buybest" element={<RepairsServiceBuybest />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/order" element={<Order />} />
                <Route path="/order/:id" element={<CurrentOrder />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/requests" element={<Requests />} />
                <Route path="/exchanges" element={<Exchanges />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product" element={<Product />} />
                <Route path="/product/:id" element={<CurrentProduct />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/models" element={<Models />} />
                <Route path="/features/:id" element={<Features />} />
                <Route path="/reports_order" element={<ReportsOrder />} />
                <Route path="/reports_bonuses" element={<ReportsBonuses />} />
                <Route path="/reports_products" element={<ReportsProducts />} />
                <Route path="/reports_repairs" element={<ReportsRepairs />} />
                <Route path="/reports_shipper" element={<ReportsShipper />} />
                <Route path="/reports_web" element={<ReportsWeb />} />
                <Route path="/reports_sync" element={<ReportsSync />} />
                <Route path="/import" element={<Import />} />
                <Route path="/export" element={<Export />} />
                <Route path="/stores/:id" element={<Stores />} />
                <Route path="/managers/:id" element={<Managers />} />
                <Route path="/shippers/:id" element={<Shippers />} />
                <Route path="/shipper/:id" element={<CurrentShipper />} />
                <Route path="/services/:id" element={<Services />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/request" element={<Request />} />
                <Route path="/category" element={<Category />} />
                <Route path="/category/:id" element={<CurrentCategory />} />
                <Route path="/model" element={<Model />} />
                <Route path="/model/:id" element={<CurrentModel />} />
                <Route path="/feature" element={<Feature />} />
                <Route path="/feature/:id" element={<CurrentFeature />} />
                <Route path="/store" element={<Store />} />
                <Route path="/store/:id" element={<CurrentStore />} />
                <Route path="/manager" element={<Manager />} />
                <Route path="/manager/:id" element={<CurrentManager />} />
                <Route path="/shipper" element={<Shipper />} />
                <Route path="/service" element={<Service />} />
                <Route path="/service/:id" element={<CurrentService />} />
                <Route path="/logs_backup" element={<LogsBackup />} />
                <Route path="/client" element={<Client />} />
                <Route path="/client/:id" element={<CurrentClient />} />
                <Route path="/barcode/:id/:qty" element={<PrintBarcode />} />
                <Route path="/print_repair/:id" element={<PrintRepair />} />
                <Route path="/print_order/:id" element={<PrintOrder />} />
                <Route path="/request/:id" element={<CurrentRequest />} />
            </Route>
        </Routes>
    );
};

export default Rotes;
